export const clearAuthStorage = () => {
  if (typeof window === "undefined") return;

  const { localStorage } = window;
  localStorage.removeItem("idToken");
  localStorage.removeItem("sat_user");

  Object.keys(localStorage)
    .filter((key) => key.startsWith("CognitoIdentityServiceProvider."))
    .forEach((key) => localStorage.removeItem(key));
};
